export default "__VITE_ASSET__9663b8ab__"